import { render, staticRenderFns } from "./ButtonLink.vue?vue&type=template&id=7126e318&scoped=true&"
import script from "./ButtonLink.vue?vue&type=script&lang=js&"
export * from "./ButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLink.vue?vue&type=style&index=0&id=7126e318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7126e318",
  null
  
)

export default component.exports